module.exports = {
  name: 'text', base: '_field', prototype: {
    element_selector: 'textarea'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/text.js
 ** module id = 38
 ** module chunks = 0
 **/